import { useEffect } from 'react';
import Cookies from 'js-cookie';

/**
 * Hook para mostrar un snackbar cuando un aviso se guarda desde el publicador de inmobiliarias.
 *
 * @param {Function} setFinishedAction - Setter del estado para el SnackBar.
 * @param {Function} t - Función de traducción i18next.
 */
const usePostingSavedSnackbar = (setFinishedAction, t) => {
  useEffect(() => {
    const actionFromNewPublisherCookie = Cookies.get('postingSavedMessage');

    if (actionFromNewPublisherCookie) {
      setFinishedAction({
        postingId: '',
        action: 'postingSaved',
        result: 'SUCCESS',
        component: t(actionFromNewPublisherCookie),
        keepOpen: false
      });
    }

    Cookies.remove('postingSavedMessage');
  }, [setFinishedAction, t]);
};

export default usePostingSavedSnackbar;
